module.exports = __webpack_public_path__ + "static/media/clear_day.d756fe71.png";